export default __webpack_public_path__ + "2e250493bc0e75625d4d76b5bc31d21f.png";